import { FEATURES, isFeatureEnabled } from 'utilities/features'

import axios from 'axios'
import { checkCart } from 'cart'
import { getDefaultDeliveryDates } from 'utilities/calendar'
import { handleNetworkError } from 'actions/Error'
import moment from 'moment'
import orderBy from 'lodash/orderBy'
import { setDeliveryDate } from 'actions/Checkout'
import { setRegionByRegionId } from 'actions/Regions'
import { formatAddress } from 'utilities/address'
import { canDeliver, getEarliestDeliveryDate } from 'utilities/distribution'
import { showNotification } from 'notification'
import i18n from 'utilities/i18n'
import { getDateAsText } from 'utilities/date'

export function getDistributionForRegion(transportProduct) {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_DISTRIBUTION_FOR_REGION',
            payload: { transportProduct },
        })
        const fromDate = moment().format('YYYY-MM-DD')
        const toDate = moment().add(10, 'days').format('YYYY-MM-DD')
        axios
            .get(
                `${process.env.AH_URL}/${process.env.AH_COUNTRYCODE}/distributionDates/${process.env.AH_CUSTOMER_SYSTEM}-${transportProduct}/${fromDate}/${toDate}`,
                {
                    params: {
                        apiKey: process.env.AH_API_KEY,
                    },
                }
            )
            .then((response) => {
                const dates = formatAndSaturateDistributionDates(response.data.distributions)
                dispatch(updateDeliveryDate(dates))
                dispatch(toggleCanDeliver(dates))
                dispatch({
                    type: 'FETCH_DISTRIBUTION_FOR_REGION_SUCCESS',
                    payload: dates,
                })
                dispatch(checkCart())
            })
            .catch((err) => {
                dispatch({
                    type: 'FETCH_DISTRIBUTION_FOR_REGION_FAILED',
                    payload: err,
                })
                dispatch(handleNetworkError(err, true))
            })
    }
}

export function getDistributionForAddress(address, isNewAddress) {
    return (dispatch) => {
        dispatch({ type: 'FETCH_DISTRIBUTION_FOR_ADDRESS' })
        axios
            .post(`${process.env.CRUX_API}/distribution/check`, {
                address: {
                    countryCode: address.countryCode,
                    postalName: address.city,
                    zipCode: address.zip,
                    streetAddress: formatAddress(address),
                    recipient: '-',
                },
            })
            .then((response) => {
                var dates = response.data.dates.map((d) => ({
                    canDeliver: d.delivery,
                    ...d,
                }))
                dates = orderBy(dates, 'date', 'asc')
                dispatch(updateDeliveryDate(dates))
                dispatch(toggleCanDeliver(dates, isNewAddress))
                dispatch({
                    type: 'FETCH_DISTRIBUTION_FOR_ADDRESS_SUCCESS',
                    payload: dates,
                })
                dispatch(setRegionByRegionId(response.data.regionId))
                dispatch(checkCart())
            })
            .catch((err) => {
                dispatch({
                    type: 'FETCH_DISTRIBUTION_FOR_ADDRESS_FAILED',
                    payload: err,
                })
                console.error('Address check failed', err)
                dispatch(handleNetworkError(err, true))
            })
    }
}

export function fetchDeadline(regionId, deliveryPointId, zipCode) {
    return (dispatch, getState) => {
        dispatch({ type: 'FETCH_DEADLINE' })
        const params = isFeatureEnabled(getState().features, FEATURES.DYNAMIC_DEADLINE)
            ? {
                  deliveryPointId: deliveryPointId,
                  zipCode: zipCode,
              }
            : {}
        axios
            .get(`${process.env.CORE_API}/region/${regionId}/deadline`, {
                params,
            })
            .then((response) => {
                dispatch({ type: 'FETCH_DEADLINE_SUCCESS', payload: response.data })
            })
    }
}

export function fetchSubscriptionDeadline(regionId) {
    return (dispatch) => {
        dispatch({ type: 'FETCH_SUBSCRIPTION_DEADLINE' })
        axios
            .get(`${process.env.CORE_API}/region/${regionId}/subscription-deadline`, {})
            .then((response) => {
                dispatch({
                    type: 'FETCH_FETCH_SUBSCRIPTION_DEADLINE_DEADLINE_SUCCESS',
                    payload: response.data.changeTomorrowDeadline.deadline,
                })
            })
    }
}

function toggleCanDeliver(dates, newAddress) {
    return (dispatch) => {
        const canDeliver = dates.filter((d) => d.canDeliver).length > 0
        dispatch({ type: 'TOGGLE_CAN_DELIVER', payload: canDeliver })
        if (newAddress) {
            dispatch({ type: 'CAN_DELIVER_TO_NEW_ADDRESS', payload: { canDeliver } })
        }
    }
}

function updateDeliveryDate(dates) {
    return (dispatch, getState) => {
        const currentDeliveryDate = getState().checkout.deliveryDate
        const deadline = getState().distribution.deadline

        const currentDate = dates.find((d) => d.date === currentDeliveryDate)
        const canDeliverOnCurrentDate = currentDate && canDeliver(currentDate, deadline)

        if (!canDeliverOnCurrentDate) {
            const earliestDeliveryDate = getEarliestDeliveryDate(dates, deadline)

            if (!earliestDeliveryDate) {
            } else {
                dispatch(setDeliveryDate(earliestDeliveryDate, false))

                if (currentDeliveryDate) {
                    dispatch({ type: 'SHOW_DELIVERY_DATE_CHANGED_NOTIFICATION' })
                }
            }
        } else if (currentDate.capacityStatus === 'NEARLY_FULL' && i18n.isInitialized) {
            dispatch(
                showNotification({
                    style: 'INFO',
                    text: i18n.t('capacityNearlyFullAnnouncement', {
                        dateText: getDateAsText(currentDate.date, true),
                    }),
                })
            )
        }
    }
}

function formatAndSaturateDistributionDates(dates) {
    const distributionDates = getDefaultDeliveryDates()
    return distributionDates.map((d) => {
        return {
            date: d,
            canDeliver: dates.includes(d),
            message: 'from region',
        }
    })
}
